import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { SearchRequest } from 'src/app/common/models/search-request';
import { SearchResult } from 'src/app/common/models/search-result';
import { DetailsService } from 'src/app/common/services/details.service';
import { PreviewContentService } from 'src/app/common/services/preview-content.service';

export enum NavigationOptions {
  Back = 1,
  Previous = 2,
  Next = 3
}

@Component({
  selector: 'rpc-pi-summary-preview',
  templateUrl: './pi-summary-preview.component.html',
  styleUrls: ['./pi-summary-preview.component.scss']
})
export class PISummaryPreviewComponent implements OnInit, OnDestroy {

  @Input() study?: SearchResult;
  @Input() showPrevious: boolean = true;
  @Input() showNext: boolean = true;
  @Output() navigationEvent: EventEmitter<NavigationOptions> = new EventEmitter();

  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  isCancerRelatedStudy?: boolean;

  private subscriptionList: Subscription[] = [];

  constructor(private router: Router,private previewContentService : PreviewContentService, private detailsService: DetailsService) { }

  ngOnInit(): void {
    if (this.study?.mayo_irb_number) {
      // Fetch whether the study is cancer-related
      this.subscriptionList.push(this.detailsService.isCancerRelatedStudy(this.study.mayo_irb_number).subscribe(isCancer => {
        this.isCancerRelatedStudy = isCancer;
      }));
    }
  }

  ngOnDestroy(): void {
    this.subscriptionList.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  /***** Click Handlers *****/

  handleBackClicked(): void {
    this.navigationEvent.emit(NavigationOptions.Back);
  }

  handlePreviousClicked(): void {
    this.navigationEvent.emit(NavigationOptions.Previous);
  }

  handleNextClicked(): void {
    this.navigationEvent.emit(NavigationOptions.Next);
  }
  
  redirectToViewProtocolPage() : void {
    this.router.navigate(['/details/'+ this.study?.mayo_irb_number +'/detail']);
    this.previewContentService.setFromPISummary(true);
  }

}
